<template>
  <div class="sub-menu-container">
    <div class="sub-menu-header">
      <van-icon name="revoke" size="24px" @click="backToMainMenu" />
      <div class="sub-menu-title">{{$t('view.popupMenu.productCategory')}}</div>
    </div>
    <div class="sub-menu-separator" />
    <div class="sub-menu-content">
      <div class="sub-menu-type-title">{{ category.value }}</div>
      <!-- <div class="sub-menu-mini-divider" /> -->
      <div class="sub-menu-item" v-for="item in category.children" :key="item.id" @click="clickMenuItem(item)">
        <div class="sub-menu-item-text">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupSubMenu',
  props: {
    category: {
      type: Object,
      default: () => ({
        id: '',
        value: '',
        children: []
      })
    }
  },
  data() {
    return {
    }
  },
  methods: {
    backToMainMenu() {
      this.$emit('back-to-main-menu')
    },
    clickMenuItem(item) {
      this.$emit('click-menu-item', item)
    }
  }
}
</script>

<style>
.sub-menu-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.sub-menu-header {
  background-color: #232f3e;
  color: white;
  display: flex;
  align-items: center;
  padding: 20px;
}

.sub-menu-header .van-icon {
  color: white;
  cursor: pointer;
  margin-right: 15px;
}

.sub-menu-title {
  color: white;
  font-size: 18px;
  font-weight: 700;
  padding: 15px 0;
}

.sub-menu-type-title {
  font-size: 18px;
  font-weight: 700;
  padding: 0 0 15px 0;
}

.sub-menu-content {
  flex: 1;
  padding: 20px;
}

.sub-menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.sub-menu-item-text {
  font-size: 16px;
  color: #111;
}

.sub-menu-separator {
  border-bottom: 6px solid #d5dbdb;
  padding: 0;
  display: block;
}

.sub-menu-mini-divider {
  padding: 0;
  border-bottom: 1px solid #d5dbdb;
  margin: 5px 0px 5px 0px;
  display: block;
}
</style>